<template>
  <div id="main">
    <div id="title">
      <vue-typer :text=msg erase-style='clear' :pre-erase-delay='5000'></vue-typer>
    </div>
    <div class="vue-logo">
      made with <img :src="vueLogo">
    </div>
    <vue-particles
      color="#7B68EE"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#7B68EE"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  export default {
    name: "Home",
    created: function () {
      this.$store.dispatch('tabAction', 0)
    },
    computed: {
      ...mapGetters('Home',{
        'msg': 'getTitle',
        'vueLogo': 'getVueLogo',
      })
    }
  }
</script>

<style lang="stylus" scoped>
  #title{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 90%;
  }
  #main{
    height: 100vh;
    width: 100vw;
  }
  #particles-js{
    postion: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 640px){
    .vue-typer{
      font-size: 2rem;
    }
  }
  .vue-logo{
    position: fixed;
    bottom: 0;
    margin: 0;
    left: 50%;
    transform: translate(-50%);
    img{
      width:40px;
      vertical-align :middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue